import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function Benefits() {
  return <section id="benefits" className="w-full py-12 md:py-24 bg-gradient-to-br from-navy-50 to-sage-50" data-id="element-12">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-15">
            Your Morning Routine = Your Identity
          </h2>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl mt-4" data-id="element-16">
            Every morning, you make a choice:
          </p>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl" data-id="element-17">
            Are you reinforcing burnout or building your best self?
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-18">
          <div className="mx-auto flex items-center justify-center" data-id="element-19">
            <div className="relative h-[400px] w-[350px] overflow-hidden rounded-xl shadow-xl" data-id="element-20">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4B4on8w6WosxPMUXB17N39/product_image.png" alt="FocusFlow Product" className="absolute inset-0 object-cover w-full h-full object-contain" data-id="element-21" />
            </div>
          </div>
          <div className="flex flex-col justify-center space-y-4" data-id="element-22">
            <p className="text-gray-700 md:text-lg" data-id="element-23">
              When you brew FocusFlow, you're telling your nervous system: we do
              things differently now.
            </p>
            <div className="space-y-4 mt-6" data-id="element-24">
              <div className="flex items-center" data-id="element-25">
                <CheckCircleIcon className="h-6 w-6 text-sage-600 mr-2" data-id="element-26" />
                <p className="text-lg font-medium" data-id="element-27">Calm &gt; Chaos</p>
              </div>
              <div className="flex items-center" data-id="element-28">
                <CheckCircleIcon className="h-6 w-6 text-sage-600 mr-2" data-id="element-29" />
                <p className="text-lg font-medium" data-id="element-30">
                  Progress &gt; Procrastination
                </p>
              </div>
              <div className="flex items-center" data-id="element-31">
                <CheckCircleIcon className="h-6 w-6 text-sage-600 mr-2" data-id="element-32" />
                <p className="text-lg font-medium" data-id="element-33">
                  Internal power &gt; External stimulation
                </p>
              </div>
            </div>
            <p className="text-xl font-bold text-sage-600 mt-6" data-id="element-34">
              This isn't just a drink. It's a new standard.
            </p>
          </div>
        </div>
      </div>
    </section>;
}